import React, { useEffect, useState } from "react";
import axios from "axios";
import Grid from "../components/Grid";
import { FaPlus, FaDownload, FaEye, FaArrowDown, FaArrowUp } from "react-icons/fa";
import { toast } from "react-toastify";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import ReimbursementModal from "../components/ReimbursementModal";
import ClaimModal from "../components/ClaimModal";
import CloseCashBookModal from "../components/CloseCashBookModal";
import CloseCashBookTable from "../components/CloseCashBookTable";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;

function CashBook(props) {

    const [cashbooks,setCashbooks] = useState([]);
    const [requests,setRequests] = useState([]);
    const [categories,setCategories] = useState([]);
    const [locations,setLocations] = useState([]);
    const [showModal,setShowModal] = useState(false);
    const [search,setSearch] = useState("");
    const [pendingCount,setPendingCount] = useState(0);
    const [mode,setMode] = useState("create");
    const [selectedCashBook,setSelectedCashBook] = useState(null);
    const [openCategoryDropdown, setOpenCategoryDropdown] = useState(false);
    const [transactions, setTransactions] = useState([]);
    const [loadingTx, setLoadingTx] = useState(false);
    const [loadingApprove, setLoadingApprove] = useState(null);
    const [showViewModal, setShowViewModal] = useState(false);
    const [showReimbursementModal, setShowReimbursementModal] = useState(false);
    const [showCloseConfirm, setShowCloseConfirm] = useState(false);
    const [showClaimModal, setShowClaimModal] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    const [selectedReimbursements, setSelectedReimbursements] = useState([]);
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10
    });
    const [totalRows, setTotalRows] = useState(0);
    const [formData,setFormData] = useState({
        category:"",
        location:"org",
        status: "Active",
    });

    const [requestForm,setRequestForm] = useState({
        requested_category:"",
        description:""
    });
    const [editingTransaction, setEditingTransaction] = useState(null);
    const token = sessionStorage.getItem("token");
    const user = JSON.parse(sessionStorage.getItem("user") || "{}");
    const role = user.role || "";
    const isAdmin = role === "Company Admin";
    console.log("TOKEN:", token);

    useEffect(()=>{
        fetchCashBooks();
        fetchCategories();
        fetchLocations();
        fetchPendingRequests();
        fetchRequests();
    },[]);

    useEffect(() => {
        if (props.openRequestModal) {
            setMode("request");
            setShowModal(true);

            setRequestForm(prev => ({
                ...prev,
                requested_category: props.categoryId
            }));
        }
    }, [props]);

    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         if (!showModal) {
    //             fetchCashBooks();
    //         }
    //     }, 3000);
    //
    //     return () => clearInterval(interval);
    // }, [showModal]);

    useEffect(() => {
        fetchCashBooks();
    }, [paginationModel]);

    useEffect(() => {

        const refreshHandler = async () => {

            await fetchCashBooks();
            await fetchRequests();
            await fetchPendingRequests();

            if (selectedCashBook?._id) {
                await fetchTransactions(
                    selectedCashBook._id
                );
            }
        };

        window.addEventListener(
            "pettycash-updated",
            refreshHandler
        );

        return () => {

            window.removeEventListener(
                "pettycash-updated",
                refreshHandler
            );
        };

    }, [selectedCashBook]);

    const fetchCashBooks = async () => {

        try{

            const res = await axios.get(
                `${API_BASE_URL}/cashbook/get?page=${paginationModel.page + 1}&limit=${paginationModel.pageSize}`,
                {headers:{Authorization:`Bearer ${token}`}}
            );

            const formatted = (res?.data?.data || []).map(cb=>({
                ...cb,
                created_by_username: cb.created_by?.username || "Unknown User",
                category_code: cb.category?.category_code || "-",
                category_name: cb.category?.category_name || "-",
                location_name: cb.location?.location_name || "Organization"
            }));

            console.log("CASHBOOK DATA:", res.data.data);

            setCashbooks(formatted);
            setTotalRows(res.data.totalRecords || 0);

            if (selectedCashBook?._id) {

                const updated = formatted.find(
                    item => item._id === selectedCashBook._id
                );

                if (updated) {
                    setSelectedCashBook(updated);
                }
            }

        }catch(e){

            toast.error("Error loading cashbooks");

        }

    };

    const fetchRequests = async()=>{

        try{

            const res = await axios.get(
                `${API_BASE_URL}/cashbook-request/get`,
                {headers:{Authorization:`Bearer ${token}`}}
            );

            console.log("API RESPONSE:", res.data.data);

            setRequests(res.data.data || []);

        }catch(err){

            console.log(err);

        }

    };

    const fetchPendingRequests = async()=>{

        try{

            const res = await axios.get(
                `${API_BASE_URL}/cashbook/get`,
                {headers:{Authorization:`Bearer ${token}`}}
            );

            const pending = (res?.data?.data || []).filter(cb=>cb.status==="ClosedPendingApproval");

            setPendingCount(pending.length);

        }catch(e){

            console.log(e);

        }

    };

    const fetchTransactions = async (cashbookId) => {
        try {
            if (!cashbookId) {
                console.log("❌ NO ID");
                return;
            }
            setLoadingTx(true);

            const res = await axios.get(
                `${API_BASE_URL}/cashbook/transactions/${cashbookId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            console.log("TX RESPONSE:", res.data);

            setTransactions(res.data.data || []);

        } catch (err) {
            console.log("ERROR:", err.response?.data || err.message);
            toast.error("Failed to load transactions");
        } finally {
            setLoadingTx(false);
        }
    };

    const fetchCategories = async()=>{

        try{

            const res = await axios.get(
                `${API_BASE_URL}/cashbook-category/get`,
                {headers:{Authorization:`Bearer ${token}`}}
            );

            setCategories(res.data.data || []);

        }catch(err){

            toast.error("Error loading categories");

        }

    };

    const fetchLocations = async()=>{

        try{

            const res = await axios.get(
                `${API_BASE_URL}/locations`,
                {headers:{Authorization:`Bearer ${token}`}}
            );

            setLocations(res.data.locations || []);

        }catch(err){

            console.log(err);

        }

    };

    const handleChange = (e) => {

        const { name, value } = e.target;

        let finalValue = value;

        if(name === "location" && value === "org"){
            finalValue = null;
        }

        setFormData(prev => ({
            ...prev,
            [name]: finalValue
        }));

    };

    const handleView=(row)=>{
        if (!row?._id) {
            console.log("❌ Invalid row:", row);
            return;
        }

        setMode("view");
        setSelectedCashBook(row);
        setShowViewModal(true);

        setFormData({
            category: row.category?._id,
            location: row.location?._id || "",
            opening_balance: row.opening_balance,
            status: row.status
        });

        fetchTransactions(row._id);
        setShowModal(true);
    };

    const handleAddClaim = () => {
        if (!selectedCashBook?._id) return;

        setShowClaimModal(true);
    };

    const handleAddReimbursement = () => {
        if (!selectedCashBook?._id) return;

        setShowReimbursementModal(true);
    };



    const createCashBook = async()=>{

        try{

            await axios.post(
                `${API_BASE_URL}/cashbook/create`,
                formData,
                {headers:{Authorization:`Bearer ${token}`}}
            );

            toast.success("CashBook created");

            setShowModal(false);
            fetchCashBooks();

        }catch(err){

            toast.error(err.response?.data?.message || "Error creating CashBook");

        }

    };

    const updatedCashBook = async()=>{
        try {

            await axios.put(
                `${API_BASE_URL}/cashbook/update/${selectedCashBook._id}`,
                {
                    opening_balance: formData.opening_balance,
                    status: formData.status
                },
                {headers:{Authorization:`Bearer ${token}`}}
            );

            toast.success("CashBook updated");

            setShowModal(false);
            fetchCashBooks();
            
        }catch (err) {
            toast.error(err.response?.data?.message || "Error updating CashBook");
        }
    }

    const requestClose = async(id)=>{

        try{

            await axios.put(
                `${API_BASE_URL}/cashbook/request-close/${id}`,
                {},
                {headers:{Authorization:`Bearer ${token}`}}
            );

            toast.success("Close request submitted");

            await fetchCashBooks();

            window.dispatchEvent(
                new Event("pettycash-updated")
            );

        }catch(err){

            toast.error(err.response?.data?.message || "Error requesting close");

        }

    };

    const requestCashBook = async()=>{

        try{

            await axios.post(
                `${API_BASE_URL}/cashbook-request/create`,
                requestForm,
                {headers:{Authorization:`Bearer ${token}`}}
            )

            toast.success("CashBook request submitted");

            setShowModal(false);

            setRequestForm({
                requested_category:"",
                description:""
            })

            fetchRequests();

        }catch(err){

            toast.error(err.response?.data?.message || "Request failed")

        }

    }

    const handleApprove = async (id) => {
        try {
            setLoadingApprove(id);
            const req = requests.find(r => r._id === id);

            const selectedCategory = categories.find(
                (c) => c._id === req?.requested_category
            );

            await axios.put(
                `${API_BASE_URL}/cashbook-request/approve/${id}`,
                { category_id: selectedCategory?._id },
                { headers:{Authorization:`Bearer ${token}`} }
            );

            toast.success("Approved successfully");
            fetchRequests();
            fetchCashBooks();

        } catch (err) {
            toast.error(err.response?.data?.message || "Error");
        } finally {
            setLoadingApprove(null);
        }
    };

    const approveClose = async (id) => {
        try {
            await axios.put(
                `${API_BASE_URL}/cashbook/approve-close/${id}`,
                {},
                { headers: { Authorization: `Bearer ${token}` } }
            );

            toast.success("CashBook Closed Successfully");
            await fetchCashBooks();
            await fetchPendingRequests();

            window.dispatchEvent(
                new Event("pettycash-updated")
            );

        } catch (err) {
            toast.error(err.response?.data?.message || "Error approving");
        }
    };

    const rejectClose = async (id) => {
        try {
            await axios.put(
                `${API_BASE_URL}/cashbook/reject-close/${id}`,
                {},
                { headers: { Authorization: `Bearer ${token}` } }
            );

            toast.success("Close request rejected");
            await fetchCashBooks();
            await fetchPendingRequests();

            window.dispatchEvent(
                new Event("pettycash-updated")
            );

        } catch (err) {
            toast.error(err.response?.data?.message || "Error rejecting");
        }
    };

    const handleReject = async (id) => {
        try {

            await axios.put(
                `${API_BASE_URL}/cashbook-request/reject/${id}`,
                {},
                { headers:{Authorization:`Bearer ${token}`} }
            );

            toast.success("Rejected successfully");
            fetchRequests();

        } catch (err) {
            toast.error(err.response?.data?.message || "Error");
        }
    };

    // const handleClaimAgain = async (row) => {
    //     try {
    //         await axios.post(
    //             `${API_BASE_URL}/pettycash/transaction`,
    //             {
    //                 cash_book: row.cash_book._id,
    //                 category: row.category._id,
    //                 transaction_type: "Claim",
    //                 amount: row.amount,
    //                 related_reimbursement: row._id
    //             },
    //             { headers: { Authorization: `Bearer ${token}` } }
    //         );
    //
    //         toast.success("Claim request created");
    //
    //         fetchTransactions(selectedCashBook._id);
    //
    //     } catch (err) {
    //         toast.error(err.response?.data?.message || "Error");
    //     }
    // };

    const handleConfirmReceived = async (row) => {
        try {
            await axios.post(
                `${API_BASE_URL}/pettycash/confirm-received/${row._id}`,
                {},
                { headers: { Authorization: `Bearer ${token}` } }
            );

            toast.success("Money received confirmed");

            await fetchTransactions(selectedCashBook._id);

            await fetchCashBooks();

            const updatedRes = await axios.get(
                `${API_BASE_URL}/cashbook/get?page=1&limit=100`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            const updatedCashbook = updatedRes.data.data.find(
                cb => cb._id === selectedCashBook._id
            );

            if (updatedCashbook) {
                setSelectedCashBook(updatedCashbook);
            }

            window.dispatchEvent(
                new Event("pettycash-updated")
            );

        } catch (err) {
            toast.error(err.response?.data?.message || "Error");
        }
    };

    const toggleReimbursement = (row) => {

        const exists = selectedReimbursements.find(
            r => r._id === row._id
        );

        if (exists) {

            setSelectedReimbursements(prev =>
                prev.filter(r => r._id !== row._id)
            );

        } else {

            setSelectedReimbursements(prev => [...prev, row]);

        }
    };

    const handleEditTransaction = (row) => {
        setEditingTransaction(row);

        if (row.transaction_type === "Claim") {
            setShowClaimModal(true);
        }

        if (row.transaction_type === "Reimbursement") {
            setShowReimbursementModal(true);
        }
    };



    const getImageUrl = (path) => {
        if (!path) return "";

        if (path.startsWith("http")) return path;

        return `${IMAGE_BASE_URL}/${path}`;
    };

    const filtered = cashbooks.filter(cb => {
        const keyword = search.toLowerCase();

        return (
            cb?.cash_book_code?.toLowerCase().includes(keyword) ||
            cb?.category_name?.toLowerCase().includes(keyword) ||
            cb?.location_name?.toLowerCase().includes(keyword) ||
            cb?.created_by?.username?.toLowerCase().includes(keyword)
        );
    });

    

    const closeRequests = cashbooks.filter(
        cb =>
            cb.status === "ClosedPendingApproval" ||
            cb.status === "Closed"
    );

    const columns=[

        {
            field:"cash_book_code",
            headerName:"CashBook Code",
            flex:1
        },

        {
            field:"category_name",
            headerName:"CashBook Name",
            flex:1
        },

        {
            field:"location_name",
            headerName:"Location",
            flex:1,
            renderCell: (params) => {
                const user = params.row.created_by?.username || "Unknown";
                const loc = params.row.location;

                // ✅ FIX
                if (!loc) {
                    return (
                        <div className="flex flex-col">
                            <span className="font-medium text-gray-800">
                                🏢 Organization
                            </span>
                            <span className="text-xs px-2 py-0.5 rounded w-fit bg-gray-100 text-gray-600">
                                Default
                            </span>
                            <span className="text-gray-700 font-medium">
                                👤 {user}
                            </span>
                        </div>
                    );
                }

                const type = loc.location_type;

                const iconMap = {
                    Farm: "🌾",
                    Outlet: "🏪"
                };

                const colorMap = {
                    Farm: "bg-green-100 text-green-700",
                    Outlet: "bg-blue-100 text-blue-700"
                };

                return (
                    <div className="flex flex-col">
                        <span className="font-medium text-gray-800">
                            {iconMap[type] || "📍"} {loc.location_name}
                        </span>

                        <span className={`text-xs px-2 py-0.5 rounded w-fit ${colorMap[type] || "bg-gray-100 text-gray-600"}`}>
                            {type || "Location"}
                        </span>
                    </div>
                );

            }
        },
        ...(isAdmin ? [{
            field: "created_by_username",
            headerName: "Owner",
            align: "center",
            headerAlign: "center",
            flex: 1,
            renderCell: (params) => (
                <div className="w-full h-full flex justify-center items-center">
                    <span className="bg-gray-100 px-2 py-1 rounded text-xs">
                        👤 {params.row.created_by_username}
                    </span>
                </div>
            )
        }] : []),
        {
            field:"opening_balance",
            headerName:"Opening Balance",
            flex:1,
            renderCell: (params) => (
                <span className="text-gray-700 font-medium">
                    Rs {params.row.opening_balance ?? 0}</span>
            )
        },

        {
            field: "current_balance",
            headerName: "Current Balance",
            align: "center",
            headerAlign: "center",
            flex: 1,
            renderCell: (params) => {

                const balance = params.row.current_balance ?? 0;
                if (balance < 0) {
                    return (
                        <div className="text-red-600 text-sm font-semibold">
                            🔻 Rs {balance}
                            <div className="text-xs text-gray-500">
                                Please submit claim
                            </div>
                        </div>
                    );
                }

                return (
                    <div className="w-full h-full flex items-center justify-center">
                        <span className="bg-green-100 text-green-600 px-3 py-1 rounded-full text-sm font-semibold">
                            🔺 Rs {balance}
                        </span>
                    </div>
                );

            }
        },

        {
            field:"status",
            headerName:"Status",
            flex:1,
            renderCell:(params)=>{

                const status=params.row.status;

                const color =
                    status === "Active"
                        ? "bg-green-600"
                        : status === "ClosedPendingApproval"
                            ? "bg-purple-600"
                            : status === "Closed"
                                ? "bg-red-600"
                                : "bg-gray-500";

                const label = status === "ClosedPendingApproval" ? "Pending Approval" : status;

                return(
                    <span className={`${color} text-white px-2 py-1 rounded`}>{label}</span>
                );

            }
        },

        {
            field:"action",
            headerName:"Action",
            width:120,
            sortable:false,
            renderCell:(params)=>{

                if(role==="Farm User" || role==="Outlet User"){

                    return(
                        <div className="flex items-center justify-center w-full h-full">

                            <button
                                className="bg-yellow-500 hover:bg-yellow-600 text-white w-8 h-8 rounded flex items-center justify-center"
                                title="View"
                                onClick={()=>handleView(params.row)}
                            >
                                <FaEye size={14}/>
                            </button>

                        </div>
                    )
                }

                return(

                    <div className="flex items-center justify-center w-full h-full gap-2">

                        <button
                            className="bg-yellow-500 hover:bg-yellow-600 text-white w-8 h-8 rounded flex items-center justify-center"
                            title="View"
                            onClick={()=>handleView(params.row)}
                        >
                            <FaEye size={14}/>
                        </button>

                        {params.row.status==="Active" && (role==="Farm User" || role==="Outlet User") && (

                            <button
                                onClick={()=>requestClose(params.row._id)}
                                className="bg-yellow-600 hover:bg-yellow-700 text-white px-2 py-1 rounded text-xs"
                            >
                                Request Close
                            </button>

                        )}

                    </div>

                );

            }
        }

    ];

    const requestColumns = [
        {field:"request_code",headerName:"Request Code",flex:1},
        {
            field: "location",
            headerName: "Location",
            flex: 1,
            renderCell: (params) => {
                const loc = params.row.location;

                if (!loc) {
                    return (
                        <span className="bg-gray-200 text-gray-700 px-2 py-1 rounded text-xs">
                            🏢 Organization
                        </span>
                    );
                }

                const type = loc.location_type;

                const iconMap = {
                    Farm: "🌾",
                    Outlet: "🏪"
                };

                const colorMap = {
                    Farm: "bg-green-100 text-green-700",
                    Outlet: "bg-blue-100 text-blue-700"
                };

                return (
                    <div className="flex flex-col">
                        <span className="font-medium text-gray-800">
                            {iconMap[type] || "📍"} {loc.location_name}
                        </span>

                        <span className={`text-xs px-2 py-0.5 rounded w-fit ${colorMap[type] || "bg-gray-100 text-gray-600"}`}>
                            {type || "Location"}
                        </span>
                    </div>
                );

            }
        },
        {
            field: "requested_category",
            headerName: "Category",
            flex: 1,
            renderCell: (params) => {
                const cat = categories.find(
                    (c) => c._id === params.value
                );
                return cat ? cat.category_name : "-";
            }
        },
        {
            field:"description",
            headerName:"Description",
            flex:1,
            renderCell: (params) => {
                if (!params || !params.row) return "-";
                return params.row.description || "-";
            }
        },

        {
            field:"status",
            headerName:"Status",
            flex:1,
            renderCell:(params)=>{

                const status=params.row.status;

                const color =
                    status==="Pending"
                        ?"bg-yellow-500"
                        :status==="Approved"
                            ?"bg-green-600"
                            :"bg-red-600";

                return(
                    <span className={`${color} text-white px-2 py-1 rounded`}>
                    {status}
                </span>
                );
            }
        },

        ...(isAdmin ? [{
            field:"actions",
            headerName:"Actions",
            flex:1,
            renderCell:(params)=>{

                if(params.row.status !== "Pending") return null;

                return(
                    <div className="flex items-center justify-center w-full h-full gap-2">

                        <button
                            onClick={()=>handleApprove(params.row._id)}
                            className="bg-green-600 text-white px-2 py-1 rounded-full text-xs"
                        >
                            Approve
                        </button>

                        <button
                            onClick={()=>handleReject(params.row._id)}
                            className="bg-red-600 text-white px-2 py-1 rounded-full text-xs"
                        >
                            Reject
                        </button>

                    </div>
                );
            }
        }] : [])

    ];

    const userTransactionColumns = [

        {
            field: "select",
            headerName: "",
            width: 40,
            renderCell: (p) => {

                const row = p.row;

                const alreadySelectedInClaim =
                    transactions.some(
                        tx =>
                            tx.transaction_type === "Claim" &&
                            tx.related_reimbursements?.some(r => {

                                const reimbursementId =
                                    typeof r.reimbursement_id === "object"
                                        ? r.reimbursement_id?._id
                                        : r.reimbursement_id;

                                return reimbursementId?.toString() === row._id?.toString();
                            })
                    );

                const canSelect =
                    row.transaction_type === "Reimbursement" &&
                    row.claim_payment_status === "MoneyIssued" &&
                    row.reimbursement_status === "Not Claimed" &&
                    !alreadySelectedInClaim;

                if (!canSelect) return null;

                return (
                    <input
                        type="checkbox"
                        checked={selectedReimbursements.some(
                            r => r._id === row._id
                        )}
                        onChange={() => toggleReimbursement(row)}
                    />
                );
            }
        },
        {
            field: "transaction_code",
            headerName: "Code",
            flex: 1 ,
        },
        {
            field: "type",
            headerName: "Type",
            flex: 1,
            renderCell: p => {
                const map = {
                    CashInvoice: "Payment",
                    CashReceipt: "Receipt",
                    Claim: "Claim",
                    Reimbursement:
                        p.row.is_iou_reimbursement
                            ? "IOU Reimbursement"
                            : "Reimbursement",
                    IOU: "IOU",
                    IOUSettlement: "IOU Settlement"
                };
                return (

                    <div className="flex flex-col gap-1">

                        <span>
                            {map[p.row.transaction_type] ||
                                p.row.transaction_type}
                        </span>

                        {
                            p.row.is_carry_forward && (

                                <span
                                    className="
                        bg-orange-100
                        text-orange-700
                        text-[10px]
                        px-2
                        py-0.5
                        rounded
                        w-fit
                    "
                                >
                    From Previous CashBook
                </span>
                            )
                        }

                    </div>
                );
            }
        },

        {
            field: "amount",
            headerName: "Amount",
            flex: 1,
            renderCell: p => {

                const type = p.row.transaction_type;
                const isApproved = p.row.approval_status === "Approved";

                const isDecrease =
                    isApproved &&
                    ["CashInvoice", "IOU", "Reimbursement" , "IOUIssue"].includes(type);

                const isIncrease =
                    isApproved &&
                    ["CashReceipt", "Claim", "IOUSettlement"].includes(type);

                return (
                    <span className={
                        isDecrease ? "text-red-600" :
                            isIncrease ? "text-green-600" :
                                "text-gray-400"
                    }>
                        {isDecrease ? "-" : isIncrease ? "+" : ""} Rs {p.row.amount}
                    </span>
                );
            }
        },
        {
            field: "source_cashbook",
            headerName: "Source",
            flex: 1,

            renderCell: p => {

                if (!p.row.is_carry_forward) {
                    return "-";
                }

                return (

                    <span
                        className="
                    bg-orange-100
                    text-orange-700
                    px-2
                    py-1
                    rounded
                    text-xs
                "
                    >
                {p.row.source_cashbook_code}
            </span>
                );
            }
        },
        {
            field: "opening",
            headerName: "Opening",
            flex: 1,
            renderCell: p => p.row.running_opening_balance ?? "-"
        },

        {
            field: "attachments",
            headerName: "Files",
            flex: 1,
            align: "center",
            headerAlign: "center",
            renderCell: p => (
                <div className="flex gap-2 item-center justify-center">
                    {p.row.attachments?.length > 0 ? (
                        p.row.attachments.map((a, i) => {
                            const cleanPath = a.replace(/\\/g, "/").replace(/^\/+/, "");
                            const fileUrl = `${IMAGE_BASE_URL}/${cleanPath.replace(/^\/+/, "")}`;

                            return a?.endsWith(".pdf") ? (
                                <a
                                    key={i}
                                    href={fileUrl}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="text-blue-600 text-xs underline flex items-center"
                                >
                                    PDF
                                </a>
                            ) : (
                                <img
                                    key={i}
                                    src={fileUrl}
                                    alt=""
                                    className="w-10 h-10 object-cover rounded border cursor-pointer hover:scale-110 transition flex items-center"
                                    onClick={() => setPreviewImage(fileUrl)}
                                />
                            );
                        })
                    ) : (
                        "-"
                    )}
                </div>
            )
        },

        { field: "reimbursement_status",
            headerName: "Claim Status",
            flex: 1,
            align: "center",
            headerAlign: "center",
            renderCell: p => {

                // ✅ IOU
                if (p.row.transaction_type === "IOU") {

                    return (
                        <span className="bg-green-600 text-white px-2 py-1 rounded text-xs">
                            {p.row.iou_status || "Approved"}
                        </span>
                    );
                }

                // ✅ IOU SETTLEMENT
                if (p.row.transaction_type === "IOUSettlement") {

                    return (
                        <span className="bg-green-600 text-white px-2 py-1 rounded text-xs">
                            {p.row.iou_status || "Settled"}
                        </span>
                    );
                }

                // ✅ CLAIM
                if (p.row.transaction_type === "Claim") {

                    let status = "Pending";

                    if (p.row.money_received === true) {
                        status = "Money Received";
                    }
                    else if (
                        p.row.claim_payment_status === "MoneyIssued"
                    ) {
                        status = "Money Issued";
                    }

                    const color =
                        status === "Money Received"
                            ? "bg-green-600"
                            : status === "Money Issued"
                                ? "bg-yellow-500"
                                : "bg-gray-500";

                    return (
                        <span className={`${color} text-white px-2 py-1 rounded text-xs`}>
                            {status}
                        </span>
                    );
                }

                // ✅ REIMBURSEMENT
                const status = p.row.reimbursement_status;

                const color =
                    status === "Fully Claimed"
                        ? "bg-green-600"
                        : status === "Partially Claimed"
                            ? "bg-yellow-500"
                            : status === "Pending"
                                ? "bg-blue-500"
                                : "bg-gray-500";

                return (
                    <span className={`${color} text-white px-2 py-1 rounded text-xs`}>
            {status}
        </span>
                );
            }
        },

        {
            field: "date",
            headerName: "Date",
            flex: 1,
            renderCell: p =>
                new Date(p.row.transaction_date).toLocaleDateString()
        },
        {
            field: "action",
            headerName: "Action",
            flex: 1,
            renderCell: (p) => {

                const canEdit =
                    role === "Accountant" &&
                    p.row.approval_status === "Pending" &&
                    ["Claim", "Reimbursement"].includes(
                        p.row.transaction_type
                    );

                return (

                    <div className="flex gap-2 items-center justify-center w-full h-full">

                        {/* ✅ EDIT BUTTON */}
                        {
                            canEdit && (
                                <button
                                    onClick={() =>
                                        handleEditTransaction(p.row)
                                    }
                                    className="
                                        bg-blue-600
                                        hover:bg-blue-700
                                        text-white
                                        px-2
                                        py-1
                                        rounded
                                        text-xs
                                    "
                                >
                                    Edit
                                </button>
                            )
                        }

                        {/* ✅ CLAIM - CONFIRM RECEIVED */}
                        {
                            p.row.transaction_type === "Claim" &&
                            p.row.approval_status === "Approved" &&
                            p.row.claim_payment_status === "MoneyIssued" &&
                            !p.row.money_received &&
                            role === "Accountant" && (

                                <button
                                    onClick={() =>
                                        handleConfirmReceived(p.row)
                                    }
                                    className="
                                bg-green-600
                                text-white
                                px-2
                                py-1
                                rounded
                                text-xs
                            "
                                >
                                    Cash Received
                                </button>
                            )
                        }

                    </div>
                );
            }
        }
    ] ;

    const downloadExcel = async()=>{

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("CashBooks");

        worksheet.addRow([
            "Code",
            "Category Code",
            "Category Name",
            "Location",
            "Opening Balance",
            "Current Balance",
            "Status"
        ]);

        filtered.forEach(cb=>{

            worksheet.addRow([
                cb.cash_book_code,
                cb.category_code,
                cb.category_name,
                cb.location_name,
                cb.opening_balance,
                cb.current_balance,
                cb.status
            ]);

        });

        const buffer = await workbook.xlsx.writeBuffer();

        saveAs(new Blob([buffer]),"CashBooks.xlsx");

    };

    const locationColorMap = {};

    const colors = [
        "bg-green-50",
        "bg-blue-50",
        "bg-yellow-50",
        "bg-purple-50"
    ];

    const borderColors = [
        "border-green-500",
        "border-blue-500",
        "border-yellow-500",
        "border-purple-500"
    ];

    requests.forEach(req => {
        const key = req.location?._id || "-";

        if (!locationColorMap[key]) {
            const hash = key
                .split("")
                .reduce((acc, char) => acc + char.charCodeAt(0), 0);

            locationColorMap[key] = colors[hash % colors.length];
        }
    });

    return(

        <div className="p-6">

            <div className="flex justify-between items-center mb-6">

                <h1 className="text-3xl font-bold text-green-700">
                    CashBooks
                </h1>



            </div>

            <div className="bg-white p-4 rounded shadow">

                <div className="flex justify-between mb-4">

                    <input
                        type="text"
                        placeholder="Search Code / Category / Location / User"
                        value={search}
                        onChange={(e)=>setSearch(e.target.value)}
                        className="border px-3 py-2 rounded-lg focus:ring-2 focus:ring-green-500"
                    />

                    <button
                        onClick={downloadExcel}
                        className="flex items-center bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700"
                    >
                        <FaDownload className="mr-2"/>
                        Download Excel
                    </button>

                </div>

                <Grid
                    rows={filtered}
                    columns={columns}
                    getRowId={(row) => row._id || row.id}
                    rowCount={totalRows}
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    rowClassNameFn={(params) => {
                        const key = params.row.location?._id || "-";

                        const hash = key
                            .split("")
                            .reduce((acc, char) => acc + char.charCodeAt(0), 0);

                        const bg = locationColorMap[key] || "bg-gray-50";
                        const border = borderColors[hash % borderColors.length];

                        return `${bg} border-l-4 ${border}`;
                    }}
                />
            </div>

                <div className="flex justify-between items-center mb-4 mt-8">

                    <h2 className="text-2xl font-bold text-green-700">
                        {(role === "Company Admin" || role === "Accountant")
                            ? "CashBook Requests"
                            : "My CashBook Requests"}
                    </h2>

                    {(role === "Accountant") && (

                        <button
                            onClick={() => {
                                setMode("request");
                                setShowModal(true);
                            }}
                            className="bg-blue-600 text-white px-4 py-2 rounded-lg flex items-center hover:bg-blue-700"
                        >
                            <FaPlus className="mr-2" />
                            Request CashBook
                        </button>

                    )}

                </div>

            <div className="bg-white p-4 rounded shadow">



                <Grid
                    rows={requests}
                    columns={requestColumns}
                    getRowId={(row) => row._id || row.id}
                    rowClassNameFn={(params) => {
                        const key = params.row.location?._id || "-";

                        const hash = key
                            .split("")
                            .reduce((acc, char) => acc + char.charCodeAt(0), 0);

                        const bg = locationColorMap[key] || "bg-gray-50";
                        const border = borderColors[hash % borderColors.length];

                        return `${bg} border-l-4 ${border}`;
                    }}
                />
            </div>

            <CloseCashBookTable
                data={closeRequests}
                isAdmin={isAdmin}
                onApprove={approveClose}
                onReject={rejectClose}
                pendingCount={closeRequests.length}
            />

            {showModal && (

                <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">

                    <div className={`bg-white rounded-xl shadow-2xl overflow-hidden ${mode === "view" ? "w-[90vw] max-w-6xl" : "w-[520px]"}`}>

                        <div className="bg-green-700 text-white px-6 py-4  flex justify-between items-center">

                            <div className="flex items-center gap-4">

                                <h2 className="text-lg font-semibold">

                                    {mode==="create" && "Add CashBook"}
                                    {mode==="view" &&
                                        `${selectedCashBook?.category_name || ""} CashBook`
                                    }
                                    {mode==="edit" && "Edit CashBook"}
                                    {mode==="request" && "Request CashBook"}

                                </h2>

                                {/* ✅ SHOW ONLY IN VIEW MODE */}
                                {mode === "view" && (

                                    <div className="mt-2 flex items-center gap-2">
                                        <span className="text-green-100 text-sm">Current Balance</span>

                                        <span
                                            className={`px-3 py-1 rounded-full text-sm font-semibold ${
                                                Number(selectedCashBook?.current_balance || 0) >= 0
                                                    ? "bg-green-200 text-green-800"
                                                    : "bg-red-200 text-red-800"
                                            }`}
                                        >
                                            Rs{" "}
                                            {Number(
                                                selectedCashBook?.current_balance || 0
                                            ).toLocaleString()}
                                        </span>

                                    </div>

                                )}

                            </div>

                            <button
                                onClick={()=>setShowModal(false)}
                                className="text-white text-xl font-bold"
                            >
                                ×
                            </button>

                        </div>

                        <div className="p-6 space-y-4">

                            {
                                mode === "view" ? (
                                    <div>
                                        <div className="flex justify-between items-center mb-3">
                                            <h3 className="font-semibold text-green-700">
                                                Transactions
                                            </h3>

                                            {
                                                role === "Accountant" && (
                                                    <div className="flex gap-2">
                                                        <button
                                                            onClick={handleAddClaim}
                                                            disabled={selectedCashBook?.status !== "Active"}
                                                            className={`px-3 py-1 rounded text-sm ${
                                                                selectedCashBook?.status !== "Active"
                                                                    ? "bg-gray-400 cursor-not-allowed"
                                                                    : "bg-blue-600 hover:bg-blue-700 text-white"
                                                            }`}
                                                        >
                                                            + Claim
                                                        </button>

                                                        <button
                                                            onClick={handleAddReimbursement}
                                                            disabled={selectedCashBook?.status !== "Active"}
                                                            className={`px-3 py-1 rounded text-sm ${
                                                                selectedCashBook?.status !== "Active"
                                                                    ? "bg-gray-400 cursor-not-allowed"
                                                                    : "bg-green-600 hover:bg-green-700 text-white"
                                                            }`}
                                                        >
                                                            + Reimbursement
                                                        </button>

                                                        <button
                                                            onClick={() => setShowCloseConfirm(true)}
                                                            disabled={
                                                                selectedCashBook?.status !== "Active" ||
                                                                selectedCashBook?.current_balance < 0}
                                                            className={`px-3 py-1 rounded text-sm ${
                                                                selectedCashBook?.status !== "Active"
                                                                    ? "bg-gray-400 cursor-not-allowed"
                                                                    : "bg-red-600 hover:bg-red-700 text-white"
                                                            }`}
                                                        >
                                                            Close
                                                        </button>
                                                    </div>
                                                )
                                            }
                                        </div>

                                        <div className="h-[450px] w-full overflow-x-auto">
                                            {loadingTx ? (
                                                <p>Loading...</p>
                                            ) : (
                                                <Grid
                                                    rows={transactions.filter(tx => {

                                                        // =====================================
                                                        // CLAIM
                                                        // =====================================

                                                        if (tx.transaction_type === "Claim") {
                                                            return true;
                                                        }

                                                        // =====================================
                                                        // NORMAL REIMBURSEMENT
                                                        // =====================================

                                                        if (
                                                            tx.transaction_type === "Reimbursement" &&
                                                            !tx.is_iou_reimbursement
                                                        ) {
                                                            return true;
                                                        }

                                                        // =====================================
                                                        // IOU REIMBURSEMENT
                                                        // SHOW ONLY AFTER SETTLED
                                                        // =====================================

                                                        if (
                                                            tx.transaction_type === "Reimbursement" &&
                                                            tx.is_iou_reimbursement
                                                        ) {

                                                            return true;
                                                        }

                                                        // =====================================
                                                        // IOU
                                                        // SHOW ONLY BEFORE SETTLED
                                                        // =====================================

                                                        if (tx.transaction_type === "IOU") {
                                                            return tx.iou_status !== "Settled";
                                                        }

                                                        return false;
                                                    })}
                                                    columns={userTransactionColumns}
                                                    getRowId={(row) => row._id}
                                                    fixedHeight={true}
                                                />
                                            )}
                                        </div>
                                    </div>

                                ) : (
                                    <>
                                        {mode==="request" && (
                                            <div>
                                                <label className="block text-gray-700 mb-2 font-medium">Category</label>

                                                <div className="relative">
                                                    <div
                                                        onClick={() => setOpenCategoryDropdown(!openCategoryDropdown)}
                                                        className="w-full border px-4 py-2 rounded-lg cursor-pointer bg-white flex justify-between items-center"
                                                    >
                                                        <span>
                                                            {requestForm.requested_category
                                                                ? categories.find(c => c._id === requestForm.requested_category)?.category_name
                                                                : "Select Category"}
                                                        </span>
                                                        <span>▼</span>
                                                    </div>

                                                    {openCategoryDropdown && (
                                                        <div className="absolute z-50 bg-white border rounded-lg mt-1 w-full max-h-60 overflow-y-auto shadow-lg">

                                                            {categories
                                                                .filter(cat => cat.status === "Active")
                                                                .map(cat => (
                                                                <div
                                                                    key={cat._id}
                                                                    onClick={() => {
                                                                        setRequestForm({
                                                                            ...requestForm,
                                                                            requested_category: cat._id
                                                                        });
                                                                        setOpenCategoryDropdown(false);
                                                                    }}
                                                                    className={`flex justify-between items-center px-3 py-2 cursor-pointer
                                                        ${cat.status === "Inactive"
                                                                        ? "opacity-50 cursor-not-allowed"
                                                                        : "hover:bg-gray-100"
                                                                    }`}
                                                                >
                                                                    <span>{cat.category_name}</span>

                                                                    <span
                                                                        className={`text-xs px-2 py-1 rounded ${
                                                                            cat.status === "Active"
                                                                                ? "bg-green-100 text-green-700"
                                                                                : "bg-red-100 text-red-600"
                                                                        }`}
                                                                    >{cat.status}</span>
                                                                </div>
                                                            ))}

                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}

                                        {mode !== "request" && (
                                            <div>

                                                <label className="block text-gray-700 mb-2 font-medium">Location</label>

                                                <select
                                                    name="location"
                                                    value={formData.location || "org"}
                                                    onChange={handleChange}
                                                    className="w-full border border-gray-300 px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                                                >

                                                    <option value="org">
                                                        Organization - ({user?.organization})
                                                    </option>

                                                    {locations?.map(loc=>(
                                                        <option key={loc._id} value={loc._id}>
                                                            Location - {loc.location_name}
                                                        </option>
                                                    ))}

                                                </select>
                                            </div>
                                        )}

                                        <div>

                                            <label className="block text-gray-700 mb-2 font-medium">Description</label>

                                            <textarea
                                                name="description"
                                                value={mode==="request" ? requestForm.description : formData.description || ""}
                                                onChange={(e)=> {
                                                    if(mode==="request"){
                                                        setRequestForm({
                                                            ...requestForm,
                                                            description: e.target.value
                                                        });
                                                    } else {
                                                        handleChange(e);
                                                    }
                                                }}
                                                className="w-full border border-gray-300 px-4 py-2 rounded-lg"
                                            />

                                        </div>

                                        {mode !== "request" && (
                                            <div>

                                                <label className="block text-gray-700 mb-2 font-medium">
                                                    Status
                                                </label>

                                                <div className="flex gap-6">

                                                    <label className="flex items-center space-x-2">

                                                        <input
                                                            type="radio"
                                                            name="status"
                                                            value="Active"
                                                            checked={formData.status==="Active"}
                                                            onChange={handleChange}
                                                            className="accent-green-600"
                                                            disabled={mode==="view"}
                                                        />

                                                        <span>Active</span>

                                                    </label>

                                                    <label className="flex items-center space-x-2">

                                                        <input
                                                            type="radio"
                                                            name="status"
                                                            value="Inactive"
                                                            checked={formData.status==="Inactive"}
                                                            onChange={handleChange}
                                                            className="accent-green-600"
                                                            disabled={mode==="view"}
                                                        />

                                                        <span>Inactive</span>

                                                    </label>
                                                </div>
                                            </div>
                                        )}


                                        <div className="flex justify-end gap-3 pt-4">

                                            <button
                                                onClick={()=>setShowModal(false)}
                                                className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400"
                                            >
                                                Cancel
                                            </button>

                                            { mode === "create" && (
                                                <button
                                                    onClick={mode==="create" ? createCashBook : updatedCashBook}
                                                    className="px-5 py-2 bg-green-700 text-white rounded-lg hover:bg-green-800"
                                                >
                                                    Save
                                                </button>
                                            )}

                                            {mode==="request" && (
                                                <button
                                                    onClick={requestCashBook}
                                                    className="bg-blue-600 text-white px-4 py-2 rounded"
                                                >
                                                    Submit Request
                                                </button>
                                            )}

                                        </div>
                                    </>
                                )
                            }


                        </div>
                    </div>
                </div>
            )}

            <ClaimModal
                open={showClaimModal}
                onClose={() => {

                    setShowClaimModal(false);

                    setEditingTransaction(null);
                }}
                selectedCashBook={selectedCashBook}
                selectedReimbursements={selectedReimbursements}
                editData={editingTransaction}
                onSuccess={async () => {

                    await fetchTransactions(
                        selectedCashBook._id
                    );
                    await fetchCashBooks();
                    setSelectedReimbursements([]);
                    setEditingTransaction(null);
                    window.dispatchEvent(
                        new Event("pettycash-updated")
                    );

                }}
            />

            <ReimbursementModal
                open={showReimbursementModal}
                onClose={() => {

                    setShowReimbursementModal(false);

                    setEditingTransaction(null);
                }}
                selectedCashBook={selectedCashBook}
                editData={editingTransaction}
                onSuccess={async () => {

                    await fetchTransactions(
                        selectedCashBook._id
                    );

                    await fetchCashBooks();

                    setEditingTransaction(null);

                    window.dispatchEvent(
                        new Event("pettycash-updated")
                    );

                }}
            />

            <CloseCashBookModal
                open={showCloseConfirm}
                onClose={() => setShowCloseConfirm(false)}
                onConfirm={async () => {
                    await requestClose(selectedCashBook._id);
                    setShowCloseConfirm(false);
                }}
            />

            {previewImage && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
                    onClick={() => setPreviewImage(null)}
                >
                    <div className="relative">
                        <img
                            src={previewImage}
                            alt="preview"
                            className="max-h-[80vh] max-w-[90vw] rounded shadow-lg"
                        />

                        <button
                            onClick={() => setPreviewImage(null)}
                            className="absolute top-2 right-2 bg-white text-black px-2 py-1 rounded"
                        >
                            ✕
                        </button>
                    </div>
                </div>
            )}

        </div>


    );
}

export default CashBook;